type CreateVariadicExpressionReturn = {
  expressionType: string;
  operands: Record<string, unknown> &
    {
      fieldTarget: string;
      source: string;
      sourceName: string;
    }[];
  operator: string;
};

export const createVariadicExpression = (
  operatorDef: Record<string, string>,
  ...operands: Record<string, unknown> &
    {
      fieldTarget: string;
      source: string;
      sourceName: string;
    }[]
): CreateVariadicExpressionReturn => {
  if (!operatorDef?.operator) throw new Error('malformed operator');

  if (
    operatorDef?.expressionType !== 'variadic' &&
    operatorDef?.expressionType !== 'null'
  )
    throw new Error(
      `operator of expressionType '${operatorDef.expressionType}' is incompatible with variadic expressions`,
    );

  return {
    expressionType: 'variadic',
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    operands: operands || [],
    operator: operatorDef.operator,
  };
};
